module.exports = __webpack_public_path__ + "static/img/lottery_bg.06583b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery_bg.png
// module id = rd8q
// module chunks = 1